<template>
<div>

    <tti-header></tti-header>

    <div class="flex justify-center px-4">
        <div class="prose prose-sm">
            <tti-terms-body></tti-terms-body>
        </div>
    </div>

    <tti-footer></tti-footer>

</div>
</template>
<script>
export default {
    components: {
        'tti-header': () => import('./HeaderNew'),
        'tti-footer': () => import('./Footer'),
        'tti-terms-body': () => import('./TermsAndConditionsBody')
    }
}
</script>